module.exports = __webpack_public_path__ + "img/arrow-upload.e02938ca.svg";